import styles from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function ProductIntroduction() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanSinglePhase.ProductIntroduction');
    return (
        <div className={`${styles.productIntroduction}`}>
            <div className="desc">
                {t.rich('desc', {
                    s: (text: string) => <span className="high-light-text">{text}</span>,
                })}
            </div>
            <div className="bg-img">
                <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713519117066/Battery%20Technology-tuya.jpg" alt={t('title')} />
            </div>
            <div className="text-box">
                <div className="sub-title">{t('label')}</div>
                <h2 className="title">{t('title')}</h2>
                <div className="text-desc">{t('desc1')}</div>
                <div className="worp">
                    <div className="worp-item">
                        <div className="item-title first-item-title">{t('item_title1')}</div>
                        <div className="item-desc">{t('item_desc1')}</div>
                    </div>
                    <div className="worp-item">
                        <div className="item-title">{t('item_title2')}</div>
                        <div className="item-desc">{t('item_desc2')}</div>
                    </div>
                    <div className="worp-item">
                        <div className="item-title">{t('item_title3')}</div>
                        <div className="item-desc">{t('item_desc3')}</div>
                    </div>
                    <div className="worp-item">
                        <div className="item-title">{t('item_title4')}</div>
                        <div className="item-desc">{t('item_desc4')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
